import React from 'react'
import { upperCase } from 'lodash'
import { Bell } from 'lucide-react'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import type { CompanyWithWorkflowConfig } from '@/schema'
import { cn } from '@/utils/common'

interface CompanyListItemProps {
  company: CompanyWithWorkflowConfig
  isSelected: boolean
  onClick: () => void
}

export const CompanyListItem: React.FC<CompanyListItemProps> = ({
  company,
  isSelected,
  onClick,
}) => {
  const getInitials = (name: string | undefined | null): string => {
    if (!name) return ''
    return upperCase(name.slice(0, 2))
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full items-center gap-3 border-x-0 border-solid border-t-0 border-b border-gray-light-200  px-4 py-3 text-left transition-colors bg-white',
        isSelected ? 'bg-gray-light-100' : 'hover:bg-gray-light-50'
      )}
    >
      <Avatar className="flex-shrink-0 w-10 h-10">
        <AvatarFallback className="text-sm font-semibold text-white bg-blue-500">
          {getInitials(company.company_name)}
        </AvatarFallback>
      </Avatar>
      <span className="flex-1 font-medium truncate text-gray-light-900">
        {company.company_name}
      </span>
      {company.has_reminder && <Bell className="w-4 h-4 text-blue-600" />}
    </button>
  )
}
